import React, { Component } from 'react'

import Header from '../../shared/components/Header'

import { translation } from '../../utils/helpers'

import TabBar from '../../shared/elements/tabBar'
import TabItem from '../../shared/elements/tabItem'
import HttpIntegrationLog from './pages/httpIntegrationLog'
import DBSLog from './pages/dbsLog'
import ForsiTokenLog from './pages/forsiTokenLog'

class IntegrationErrorList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      selectedTabIndex: 0,
      tabs: [{
        title: 18138,
        component: HttpIntegrationLog,
        props: {
          integrationType: 0
        }
      },
      {
        title: 15352,
        component: HttpIntegrationLog,
        props: {
          integrationType: 1
        }
      },
      {
        title: 17930,
        component: DBSLog
      },
      {
        title: 18331,
        component: ForsiTokenLog
      }]
    }
  }

  render () {
    const renderTitle = (title, index) => {
      return (
        <TabItem
          key={index}
          onClick={() => this.setState({ selectedTabIndex: index })}
          labelText={translation(title.title)}
          active={this.state.selectedTabIndex === index}
        />
      )
    }

    let { component: Component, props } = this.state.tabs[this.state.selectedTabIndex]
    return (
      <div>
        <Header router={this.props.router}>
          <TabBar>
            {this.state.tabs.map(renderTitle)}
          </TabBar>
        </Header>
        <Component {...props} />
      </div>
    )
  }

}

export default IntegrationErrorList



// WEBPACK FOOTER //
// ./src/app/pages/IntegrationErrorList/index.js